import{isMotionValue as o}from"../utils/is-motion-value.mjs.js";function t(t){return Boolean(o(t)&&t.add)}export{t as isWillChangeMotionValue};
